import { dbRef } from "../../db-ref";
import { ResourceSubPipeline } from "../../utils";
import { getUserSnippetPipeline } from "../users/user-snippet-resource";
import { zReview } from "./review-resource";

const reviewServiceProjectPipeline: ResourceSubPipeline = {
  mainStages: [
    {
      $lookup: {
        from: dbRef.serviceProject.collection,
        localField: "serviceProjectId",
        foreignField: "_id",
        as: "serviceProjectDoc",
      },
    },
    {
      $unwind: {
        path: "$serviceProjectDoc",
        preserveNullAndEmptyArrays: true,
      },
    },
  ],
  projectStage: {
    "serviceProjectId": 1,
    "serviceProjectDoc.serviceId": 1,
    "serviceProjectDoc.serviceDetails.title": 1,
    "serviceProjectDoc.serviceDetails.requiredDays": 1,
  },
};

export function getReviewPipelines() {
  const reviewReviewerUserPipeline = getUserSnippetPipeline("reviewerId", "reviewerDoc");
  const reviewRevieweeUserPipeline = getUserSnippetPipeline("revieweeId", "revieweeDoc");

  return {
    _z: zReview,
    mainStages: [
      ...reviewReviewerUserPipeline.mainStages,
      ...reviewServiceProjectPipeline.mainStages,
      ...reviewRevieweeUserPipeline.mainStages,
    ],
    projectStage: {
      _id: 1,
      rating: 1,
      reviewText: 1,
      publishedAt: 1,
      showOnProfile: 1,
      ...reviewReviewerUserPipeline.projectStage,
      ...reviewServiceProjectPipeline.projectStage,
      ...reviewRevieweeUserPipeline.projectStage,
    },
    _reviewer: reviewReviewerUserPipeline,
    _serviceProject: reviewServiceProjectPipeline,
  };
}
